<template>
  <span>
    <span v-for="(item, i) in pathItems" :key="i">
      <a v-if="(isPrev(i) && clickableNodes) || (isLast(i) && clickableLeaves)" @click.stop="go(item.id)" class="path-item">
        {{ item.name }}
      </a>
      <span v-else>
        {{ item.name }}
      </span>
      <span v-if="isPrev(i)">&nbsp;&gt;&nbsp;</span>
    </span>
  </span>
</template>

<style scoped>
  a.path-item {
    color: black;
  }
  a.path-item:hover {
    text-decoration: underline;
  }
</style>

<script>
export default {
  name: 'asset-path',
  props: {
    item: {
      type: Object,
      required: true
    },
    model: {
      type: String,
      required: true,
      validator: (name) => {
        // supported models
        return ['assets', 'asset-types'].includes(name)
      }
    },
    clickableNodes: {
      type: Boolean,
      required: false,
      default: false
    },
    clickableLeaves: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    viewProp () {
      const map = {
        'assets': 'assetParentsView',
        'asset-types': 'assetTypeParentsView'
      }
      return map[this.model]
    },
    pathItems () {
      const { name, id, parentId } = this.item

      if (!parentId) {
        return [
          { name, id }
        ]
      }

      const items = []
      const { ids, names } = this.item[this.viewProp]
      for (let i in ids) {
        items.push({
          id: ids[i],
          name: names[i]
        })
      }

      return items
    }
  },
  methods: {
    isLast (i) {
      return i === this.pathItems.length - 1
    },
    isPrev (i) {
      return this.isLast(i) === false
    },
    go (id) {
      this.$router.push({
        name: `${this.model}/id`,
        params: { id }
      })
    }
  }
}
</script>
